import TechSection from "./TechSection";

const AvailableCertifications = () => {
  const arr = ["frontend", "backend", "devops", "mobile"];
  
  return (
    <div className="row mx-0 py-5 d-flex justify-content-center align-items-center">
      <div className="col-md-11 col-12">
        <div className="row mx-0 d-flex justify-content-center align-items-center">
          <div className="col-12 text-center mb-3">
            <h3 className="fw-bold  text-light ">Available Certifications</h3>
          </div>
          {arr.map((tech) => (
            <TechSection category={tech} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default AvailableCertifications;
